const SYSTEM_REPORTS_EMAIL_PREMIUM_BENEFIT: string = 'System Reports Emailed to Customers'
const HISTORICAL_SYSTEM_REPORT_STORAGE_PREMIUM_BENEFIT: string = 'Historical System Report Storage'

class Benefits {
  static readonly SYSTEM_REPORTS_EMAIL_PREMIUM_BENEFIT = SYSTEM_REPORTS_EMAIL_PREMIUM_BENEFIT
  static readonly HISTORICAL_SYSTEM_REPORT_STORAGE_PREMIUM_BENEFIT = HISTORICAL_SYSTEM_REPORT_STORAGE_PREMIUM_BENEFIT

  static readonly PREMIUM = [
    'Unlimited Access to Tech Assistant AI Chatbot in Technician App',
    'Extended Runtime History',
    'Maintenance Trends',
    SYSTEM_REPORTS_EMAIL_PREMIUM_BENEFIT,
    HISTORICAL_SYSTEM_REPORT_STORAGE_PREMIUM_BENEFIT
  ]

  static readonly STANDARD = [
    'Limited Access to Tech Assistant AI Chatbot in Technician App',
    '30 Days Runtime History',
    'Equipment Alerts and Smart Diagnostic Alerts',
    'Dealer Remote Configuration',
    'Warranty Information',
    'Service Contract Tracking',
    'Link Verification Reports'
  ]

  static values () {
    return [
      Benefits.PREMIUM,
      Benefits.STANDARD
    ]
  }
}

export default Benefits
